import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/autovex-light/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/autovex-light/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/autovex-light/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/autovex-light/locales/da/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages);


export class IconAutovexLight42 extends LitElement {
  render() {
      const title = i18n.t({ message: `AutovexLight logo`, id: 'icon.title.autovexlight', comment: 'Title for AutovexLight icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-autovex-light-42-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="#0B6DFF" d="M31.424 1.12H10.576a2.456 2.456 0 0 0-2.455 2.456v20.848c0 1.356 1.1 2.456 2.455 2.456h20.848c1.356 0 2.456-1.1 2.456-2.456V3.576c0-1.356-1.1-2.456-2.456-2.456"></path><path fill="#fff" d="M18.833 7.945h-4.007l-2.377 12.107v.003h2.766l.259-1.571h2.658l.259 1.57h2.853zm-2.988 8.31.958-5.675h.035l.94 5.675zm10.952-8.31-1.628 9.526h-.004v.006h-.03l-1.566-9.532h-2.841l2.411 12.11h4.008l2.376-12.11z"></path></svg>`; }
}
if (!customElements.get('w-icon-autovex-light-42')) {
  customElements.define('w-icon-autovex-light-42', IconAutovexLight42);
}